import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const General2 = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      {...rest}
      fill={fill}
    >
      <g transform="translate(0, 0)">
        <rect x="1" y="1" width="6" height="6" rx="1.5" />
        <path d="M13.061.818a1.5,1.5,0,0,0-2.122,0L8.817,2.939a1.5,1.5,0,0,0,0,2.122l2.121,2.121a1.5,1.5,0,0,0,2.122,0l2.122-2.121a1.5,1.5,0,0,0,0-2.122Z" />
        <rect x="1" y="9" width="6" height="6" rx="1.5" />
        <rect x="9" y="9" width="6" height="6" rx="1.5" />
      </g>
    </svg>
  );
};

General2.category = 'product-category';

General2.displayName = 'General2';
